import { createContext, ReactNode, useEffect, useState } from 'react';
import { PartnerService } from 'services';
import { PartnerStateProps } from 'types';

type PartnerProviderProps = {
  children: ReactNode;
};

export const PartnerContext = createContext({});

export const PartnerProvider = ({ children }: PartnerProviderProps) => {
  const [partner, setPartner] = useState<PartnerStateProps>(
    {} as PartnerStateProps
  );

  useEffect(() => {
    PartnerService.getAllPartners()
      .then(({ data }) => {
        setPartner(data);
      })
      .catch((err) => console.error(err));
  }, []);

  return (
    <PartnerContext.Provider value={partner}>
      {children}
    </PartnerContext.Provider>
  );
};
